/* Pikemla — PDP trust/value module
 *
 * - Paints the estimated delivery date range from the store's stated policy:
 *   ships in 1-3 business days, arrives in 5-12 business days (mirrors
 *   pk-shipping-info). Business-day math, weekends skipped, labeled "estimated".
 * - Keeps the Shop Pay installment amount in sync when the shopper picks another
 *   variant (the theme fires `variant:update` with the variant resource, which
 *   carries `price` in cents). The installments line only shows at $50+ because
 *   Shop Pay "Pay in 4" requires orders between $50 and $999.99.
 */
(function () {
  'use strict';

  var ARRIVE_EARLY_BUSINESS_DAYS = 5;
  var ARRIVE_LATE_BUSINESS_DAYS = 12;

  function addBusinessDays(date, days) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  }

  function fmtDate(d) {
    var s = d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    if (d.getFullYear() !== new Date().getFullYear()) s += ', ' + d.getFullYear();
    return s;
  }

  function moneyFromCents(cents) {
    // Installment = price / 4, formatted as USD.
    return '$' + (cents / 4 / 100).toFixed(2);
  }

  function paintDates(root) {
    var el = root.querySelector('[data-pk-tv-dates]');
    if (!el) return;
    var now = new Date();
    var early = addBusinessDays(now, ARRIVE_EARLY_BUSINESS_DAYS);
    var late = addBusinessDays(now, ARRIVE_LATE_BUSINESS_DAYS);
    el.textContent = fmtDate(early) + ' – ' + fmtDate(late);
  }

  function paintInstallments(root, priceCents) {
    var line = root.querySelector('[data-pk-tv-installments]');
    if (!line) return; // Shop Pay not enabled — nothing to do.
    var floor = parseInt(root.getAttribute('data-floor-cents') || '5000', 10);
    var amountEl = root.querySelector('[data-pk-tv-amount]');
    if (priceCents >= floor) {
      if (amountEl) amountEl.textContent = moneyFromCents(priceCents);
      line.removeAttribute('hidden');
    } else {
      line.setAttribute('hidden', '');
    }
    root.setAttribute('data-price-cents', String(priceCents));
  }

  function init() {
    var modules = document.querySelectorAll('[data-pk-trust-value]');
    if (!modules.length) return;

    modules.forEach(function (root) {
      paintDates(root);
      var initial = parseInt(root.getAttribute('data-price-cents') || '0', 10);
      if (initial) paintInstallments(root, initial);
    });

    // Keep the installment amount honest when the variant (and its price) changes.
    document.addEventListener('variant:update', function (event) {
      var resource = event && event.detail && event.detail.resource;
      if (!resource || typeof resource.price !== 'number') return;
      // Only the PDP carries this module, so the single module on the page is ours.
      var root = document.querySelector('[data-pk-trust-value]');
      if (root) paintInstallments(root, resource.price);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
